import { ShareholderInvestorPersonBankAccountsRes } from '@dealstack/shared/lib/generated';

export type StepBankAccount = ShareholderInvestorPersonBankAccountsRes['bankAccounts'][number];

/**
 * The account the bank-account step shows and therefore links: the given person's (the PIV) when
 * investing through a vehicle, otherwise the investor's own account in the current deal. Mirrors
 * how BankAccountWithCodeValidation picks the account it renders.
 */
export const resolveStepBankAccount = (
	bankAccountsData: ShareholderInvestorPersonBankAccountsRes[] | undefined,
	{ personId, dealId }: { personId?: string; dealId?: string }
): StepBankAccount | undefined => {
	if (!bankAccountsData?.length) {
		return undefined;
	}

	if (personId) {
		return bankAccountsData.find((data) => data.personId === personId)?.bankAccounts[0];
	}

	if (dealId) {
		return bankAccountsData.find((data) => data.dealId === dealId)?.bankAccounts[0];
	}

	return bankAccountsData[0]?.bankAccounts[0];
};
